import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@fontsource/geologica/300.css';
import '@fontsource/geologica/400.css';
import '@fontsource/geologica/500.css';
import '@fontsource/geologica/600.css';
import '@fontsource/geologica/700.css';
import '@/styles/globals.css';
import '@/i18n/i18n';
import '@/features/table/consts/agGridModules';

import { Providers } from '@/providers/Providers';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Providers />
  </StrictMode>
);
